export default __webpack_public_path__ + "static/media/cert-ngo-HKIRC.b65faf42.jpg";